import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconCollapse(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M9 15H6a.967.967 0 0 1-.713-.287A.968.968 0 0 1 5 14c0-.283.096-.52.287-.713A.967.967 0 0 1 6 13h4c.283 0 .52.096.713.287.191.192.287.43.287.713v4c0 .283-.096.52-.287.712A.968.968 0 0 1 10 19a.967.967 0 0 1-.713-.288A.968.968 0 0 1 9 18v-3Zm6-6h3c.283 0 .52.096.712.287.192.192.288.43.288.713s-.096.52-.288.713A.968.968 0 0 1 18 11h-4a.968.968 0 0 1-.713-.287A.968.968 0 0 1 13 10V6c0-.283.096-.52.287-.713A.968.968 0 0 1 14 5c.283 0 .52.096.713.287.191.192.287.43.287.713v3Z"
      />
    </BaseIcon>
  );
}
